// extracted by mini-css-extract-plugin
export default {"filePreviewer":"FilePreviewer_filePreviewer__lAzWT","filePreviewer__file":"FilePreviewer_filePreviewer__file__jeEiO","image":"FilePreviewer_image__B38kB"};